export enum TiposWebKeys {
  WEB = 'WEB',
  APP = 'APP'
}